import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";
import "./WebDesignKenya.css";





import { FaChevronDown } from "react-icons/fa";

import WebDesignHeroImg from "../assets/approach-bg.jpeg";



const WebDesignKenya = () => {

  const portfolioRef = useRef(null);

  const handleCTAClick = () => {
  if (window.gtag) {
    // Google Ads Contact conversion
    window.gtag("event", "conversion", {
      send_to: "AW-18400320086/w-NyCLzequUcENa0-sVE",
    });

    // Existing GA4 CTA tracking
    window.gtag("event", "click", {
      event_category: "CTA",
      event_label: "WhatsApp Web Design CTA",
      value: 1,
    });
  }
};

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Web Design in Kenya | High-Converting Websites That Grow Businesses</title>

<link rel="canonical" href="https://satimatechnova.co.ke/web-design-kenya/">
</link>

        <meta
          name="description"
          content="Professional web design in Kenya offering responsive, SEO-optimized, and fast-loading websites that help businesses attract customers and grow online."
        />

        <meta
          name="keywords"
          content="web design Kenya, website design Kenya, responsive websites Kenya, SEO websites Kenya, custom web design Kenya, Satima Technova Solutions"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Web Design in Kenya" />
        <meta property="og:description" content="High-performing websites in Kenya designed to attract customers and drive business growth." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/web-design-kenya/" />


        <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [

    {
      "@type": "Question",
      "name": "How much does website design cost in Kenya?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "At Satima Technova Solutions, website design packages are structured to suit different business needs. Starter Website Packages start from KES 12,000, Business Website Packages start from KES 18,000, and E-commerce or Advanced Website Packages start from KES 25,000. The final cost depends on the features, functionality, and requirements of the project."
      }
    },


    {
      "@type": "Question",
      "name": "How long does it take to build a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most websites are completed within 2 to 3 working days depending on the size of the project, content availability, and required features. Satima Technova Solutions focuses on delivering professional websites without compromising quality."
      }
    },


    {
      "@type": "Question",
      "name": "Will my website appear on Google?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Satima Technova Solutions builds websites with SEO-friendly structures to help search engines understand your business. We optimize important elements such as page structure, speed, and content setup to improve your chances of appearing on Google."
      }
    },


    {
      "@type": "Question",
      "name": "Do you provide website maintenance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Satima Technova Solutions provides website maintenance services to keep your website secure, updated, and performing well. This includes updates, security checks, content changes, and technical support."
      }
    },


    {
      "@type": "Question",
      "name": "Can you redesign my existing website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Satima Technova Solutions redesigns outdated websites into modern, responsive, and user-friendly platforms that improve brand image and customer experience."
      }
    }

  ]
})}
</script>


      </Helmet>

      <main className="wd-page">


        {/* WEBSITE GROWTH BENEFITS STRIP */}

<section className="growth-strip">

  <div className="growth-title">
    <h2>
      A Website Built For Business Growth
    </h2>
  </div>


  <div className="growth-track">

    {[
      "More Online Visibility",
      "Stronger Customer Trust",
      "More Business Inquiries",
      "More Potential Customers",
    ]
    .concat([
      "More Online Visibility",
      "Stronger Customer Trust",
      "More Business Inquiries",
      "More Potential Customers",
    ])
    .map((item, index) => (

      <div className="growth-item" key={index}>

        <span className="growth-check">
          ✓
        </span>

        <span>
          {item}
        </span>

      </div>

    ))}

  </div>

</section>



{/* HERO SECTION */}

<section
  className="wd-hero-section"
  style={{
    backgroundImage: `url(${WebDesignHeroImg})`
  }}
>
  <div className="wd-hero-overlay">

    <div className="wd-hero-wrapper">

      <div className="wd-hero-text">

        <span className="wd-hero-tag">
          PROFESSIONAL WEB DESIGN
        </span>

        <h1 className="visually-hidden">
          Web Design in Kenya That Helps Businesses Attract More Customers Online
        </h1>

        <div className="wd-intro-content">

          <h2>
            Websites That
            <br />
            <span>Work For You.</span>
          </h2>

          <p className="wd-intro-line">
            Modern, fast, and SEO-friendly websites designed to
            attract customers, build trust, and grow your business.
          </p>

        </div>

        <div className="wd-hero-actions">

          <a
            href="https://wa.me/254775137928?text=Hello%20Satima%20Technova%2C%20I%27m%20interested%20in%20your%20web%20design%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="wd-hero-cta"
            onClick={handleCTAClick}
          >
            Get Free Consultation
          </a>

          <a
  href="https://booking.satimatechnova.co.ke/book.php?service=1"
  className="wd-hero-secondary"
>
  Book Our Services
</a>

        </div>

        <div className="wd-hero-benefits">

          <div className="wd-benefit-item">
            <span>✓</span>
            Mobile-Friendly
          </div>

          <div className="wd-benefit-item">
            <span>✓</span>
            SEO Optimized
          </div>

          <div className="wd-benefit-item">
            <span>✓</span>
            Built For Growth
          </div>

        </div>

      </div>

    </div>

  </div>
</section>



{/* WEBSITE PROBLEM SECTION */}

<section id="website-problem" className="wd-problem-section">

  <div className="wd-problem-container">

    {/* SECTION HEADER */}

    <div className="wd-problem-header">

      <span className="wd-problem-kicker">
        THE WEBSITE GAP
      </span>

      <h2 className="wd-problem-title">
        Your website should do more
        <br />
        <span>than look good.</span>
      </h2>

      <p className="wd-problem-intro">
        A professional website should help people find your business,
        trust your brand, understand what you offer, and take the next step.
      </p>

    </div>


    {/* MAIN CONTENT */}

    <div className="wd-problem-grid">

      {/* PROBLEM */}

      <div className="wd-problem-card wd-problem-basic">

        <div className="wd-problem-card-top">

          <span className="wd-problem-number">
            01
          </span>

          <span className="wd-problem-card-label">
            A WEBSITE THAT JUST EXISTS
          </span>

        </div>

        <h3>
          Looking good isn't enough
        </h3>

        <p className="wd-problem-card-intro">
          A website can look professional and still fail to support
          the business behind it.
        </p>

        <ul>
          <li>Visitors cannot quickly find what they need</li>
          <li>Customers struggle to know what to do next</li>
          <li>Poor performance creates a weak experience</li>
          <li>Search visibility is overlooked</li>
          <li>The website does little to generate enquiries</li>
          <li>The design does not reflect the brand</li>
        </ul>

      </div>


      {/* BETTER APPROACH */}

      <div className="wd-problem-card wd-problem-strategic">

        <div className="wd-problem-card-top">

          <span className="wd-problem-number">
            02
          </span>

          <span className="wd-problem-card-label">
            A WEBSITE THAT WORKS
          </span>

        </div>

        <h3>
          Built around your customers
        </h3>

        <p className="wd-problem-card-intro">
          We design websites around your business goals, your
          customers, and the actions you want visitors to take.
        </p>

        <div className="wd-problem-points">

          <div className="wd-problem-point">

            <span>01</span>

            <p>
              Clear information and easy navigation
            </p>

          </div>


          <div className="wd-problem-point">

            <span>02</span>

            <p>
              Mobile-friendly experiences
            </p>

          </div>


          <div className="wd-problem-point">

            <span>03</span>

            <p>
              SEO-ready website structure
            </p>

          </div>


          <div className="wd-problem-point">

            <span>04</span>

            <p>
              Stronger paths to enquiries and action
            </p>

          </div>

        </div>

        <a
          href="https://wa.me/254775137928?text=Hello%20Satima%20Technova%2C%20I%27m%20interested%20in%20building%20a%20professional%20website%20for%20my%20business."
          className="wd-problem-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Discuss Your Website
        </a>

      </div>

    </div>


    {/* CLOSING STATEMENT */}

    <div className="wd-problem-bottom">

      <span className="wd-problem-bottom-line"></span>

      <p>
        Your website is often the first interaction customers have
        with your business. Make that interaction count.
      </p>

    </div>

  </div>

</section>


      {/* =========================================================
    WEBSITE SOLUTION — THE RIGHT APPROACH
========================================================= */}

<section className="wd-solution-section">

  <div className="wd-solution-container">

    {/* SECTION INTRO */}

    <div className="wd-solution-header">

      <span className="wd-solution-label">
        THE RIGHT APPROACH
      </span>

      <h2>
        A Website Should Have
        <br />
        <span>A Purpose.</span>
      </h2>

      <p>
        We build websites around what your business needs to achieve,
        how your customers behave, and the actions you want them to take.
      </p>

    </div>


    {/* SOLUTION FEATURE BLOCK */}

    <div className="wd-solution-feature">

      <div className="wd-solution-accent"></div>


      <div className="wd-solution-content">

        {/* MAIN STATEMENT */}

        <div className="wd-solution-statement">

          <span className="wd-solution-quote">
            “
          </span>

          <h3>
            Purpose.
            <br />
            Experience.
            <br />
            Results.
          </h3>

        </div>


        {/* SUPPORTING MESSAGE */}

        <div className="wd-solution-message">

          <p>
            A strong website brings together
            <strong> clarity, usability, visibility, and action.</strong>
          </p>


          <div className="wd-solution-principles">

            {/* PRINCIPLE 01 */}

            <div className="wd-solution-principle">

              <span className="wd-solution-number">
                01
              </span>

              <div>

                <h4>
                  Clarity
                </h4>

                <p>
                  Visitors should quickly understand who you are,
                  what you offer, and why they should choose you.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 02 */}

            <div className="wd-solution-principle">

              <span className="wd-solution-number">
                02
              </span>

              <div>

                <h4>
                  Experience
                </h4>

                <p>
                  Every page should make it easy for customers
                  to navigate, find information, and take action.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 03 */}

            <div className="wd-solution-principle">

              <span className="wd-solution-number">
                03
              </span>

              <div>

                <h4>
                  Visibility
                </h4>

                <p>
                  Your website should have a strong SEO foundation
                  that helps search engines understand your business.
                </p>

              </div>

            </div>


            {/* PRINCIPLE 04 */}

            <div className="wd-solution-principle">

              <span className="wd-solution-number">
                04
              </span>

              <div>

                <h4>
                  Conversion
                </h4>

                <p>
                  Visitors should have clear paths toward enquiries,
                  calls, bookings, purchases, or other meaningful actions.
                </p>

              </div>

            </div>

          </div>


          {/* HIGHLIGHT */}

          <div className="wd-solution-highlight">

            <span className="wd-solution-highlight-line"></span>

            <p>
              Your website should guide visitors from
              <strong> interest to action.</strong>
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    WHY SATIMA — BUILT AROUND YOUR BUSINESS
========================================================= */}

<section className="wd-trust-section">

  <div className="wd-trust-container">

    {/* SECTION HEADER */}

    <div className="wd-trust-header">

      <span className="wd-trust-label">
        WHY SATIMA FOR YOUR WEBSITE
      </span>

      <h2>
        Built Around Your Business.
        <br />
        <span>Not A Template.</span>
      </h2>

      <p>
        Your website should reflect how your business works,
        what your customers need, and where you want to go next.
      </p>

    </div>


    {/* MAIN TRUST EXPERIENCE */}

    <div className="wd-trust-feature">

      {/* LEFT STATEMENT */}

      <div className="wd-trust-visual">

        <span className="wd-trust-index">
          04
        </span>

        <div className="wd-trust-statement">

          <span className="wd-trust-mark">
            /
          </span>

          <h3>
            Strategy
            <br />
            before
            <br />
            <span>design.</span>
          </h3>

        </div>

        <p className="wd-trust-side-note">
          Every website starts with understanding
          the business behind it.
        </p>

      </div>


      {/* RIGHT CONTENT */}

      <div className="wd-trust-content">

        <div className="wd-trust-intro">

          <span className="wd-trust-intro-line"></span>

          <p>
            We don't begin with a template.
            <strong> We begin with your business.</strong>
          </p>

        </div>


        {/* TRUST PRINCIPLES */}

        <div className="wd-trust-principles">

          {/* 01 */}

          <div className="wd-trust-principle">

            <div className="wd-trust-number">
              01
            </div>

            <div className="wd-trust-principle-text">

              <h4>
                Business First
              </h4>

              <p>
                We understand your business, audience, goals,
                and what the website needs to accomplish.
              </p>

            </div>

          </div>


          {/* 02 */}

          <div className="wd-trust-principle">

            <div className="wd-trust-number">
              02
            </div>

            <div className="wd-trust-principle-text">

              <h4>
                Customer Focused
              </h4>

              <p>
                We structure the experience around how your
                customers search, browse, compare, and decide.
              </p>

            </div>

          </div>


          {/* 03 */}

          <div className="wd-trust-principle">

            <div className="wd-trust-number">
              03
            </div>

            <div className="wd-trust-principle-text">

              <h4>
                Performance Built In
              </h4>

              <p>
                Speed, mobile responsiveness, SEO foundations,
                security, and usability are considered from the start.
              </p>

            </div>

          </div>


          {/* 04 */}

          <div className="wd-trust-principle">

            <div className="wd-trust-number">
              04
            </div>

            <div className="wd-trust-principle-text">

              <h4>
                Ready To Evolve
              </h4>

              <p>
                Your website is built with room to improve,
                add functionality, and adapt as your business grows.
              </p>

            </div>

          </div>

        </div>


        {/* CLOSING STATEMENT */}

        <div className="wd-trust-closing">

          <p>
            A better website starts with
            <strong> a better understanding of your business.</strong>
          </p>

          <span className="wd-trust-closing-arrow">
            →
          </span>

        </div>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    WEBSITE PERFORMANCE — BUILT FOR PERFORMANCE
========================================================= */}

<section className="wd-performance-section">

  <div className="wd-performance-container">

    {/* SECTION HEADER */}

    <div className="wd-performance-header">

      <span className="wd-performance-label">
        BUILT FOR PERFORMANCE
      </span>

      <h2>
        The Details Behind
        <br />
        <span>A Better Website.</span>
      </h2>

      <p>
        Performance, responsiveness, visibility, and usability are
        built into the experience from the start.
      </p>

    </div>


    {/* PERFORMANCE INTRO */}

    <div className="wd-performance-intro">

      <div className="wd-performance-intro-number">
        05
      </div>

      <div className="wd-performance-intro-content">

        <span className="wd-performance-small-label">
          WHAT'S BUILT IN
        </span>

        <h3>
          A website should perform
          <span> as good as it looks.</span>
        </h3>

      </div>

      <div className="wd-performance-intro-line"></div>

    </div>


    {/* PERFORMANCE GRID */}

    <div className="wd-performance-grid">

      {/* PERFORMANCE 01 */}

      <div className="wd-performance-item">

        <div className="wd-performance-item-top">

          <span className="wd-performance-number">
            01
          </span>

          <span className="wd-performance-icon">
            ↗
          </span>

        </div>

        <div className="wd-performance-item-content">

          <h4>
            Fast Loading
          </h4>

          <p>
            Pages are structured to load efficiently,
            helping visitors access your content without
            unnecessary waiting.
          </p>

        </div>

      </div>


      {/* PERFORMANCE 02 */}

      <div className="wd-performance-item">

        <div className="wd-performance-item-top">

          <span className="wd-performance-number">
            02
          </span>

          <span className="wd-performance-icon">
            ◫
          </span>

        </div>

        <div className="wd-performance-item-content">

          <h4>
            Mobile First
          </h4>

          <p>
            Your website is designed to work smoothly
            across phones, tablets, and desktop screens.
          </p>

        </div>

      </div>


      {/* PERFORMANCE 03 */}

      <div className="wd-performance-item">

        <div className="wd-performance-item-top">

          <span className="wd-performance-number">
            03
          </span>

          <span className="wd-performance-icon">
            ⌕
          </span>

        </div>

        <div className="wd-performance-item-content">

          <h4>
            SEO Ready
          </h4>

          <p>
            Clean structure and essential SEO foundations
            help search engines understand your website
            and its content.
          </p>

        </div>

      </div>


      {/* PERFORMANCE 04 */}

      <div className="wd-performance-item">

        <div className="wd-performance-item-top">

          <span className="wd-performance-number">
            04
          </span>

          <span className="wd-performance-icon">
            ✓
          </span>

        </div>

        <div className="wd-performance-item-content">

          <h4>
            Secure & Reliable
          </h4>

          <p>
            SSL, reliable infrastructure, and sound
            technical practices help create a safer
            and more dependable experience.
          </p>

        </div>

      </div>

    </div>


    {/* PERFORMANCE CLOSING */}

    <div className="wd-performance-closing">

      <div className="wd-performance-closing-mark">
        +
      </div>

      <p>
        A website should feel effortless to use
        <strong> for your customers and your business.</strong>
      </p>

      <span className="wd-performance-closing-line"></span>

    </div>

  </div>

</section>




{/* =========================================================
    WEBSITE PORTFOLIO SECTION
========================================================= */}

<section className="portfolio-section">

  <div className="portfolio-header">

    <span className="portfolio-label">
      OUR PORTFOLIO
    </span>

    <p>
      Explore some of the websites we have created for businesses
      and brands looking to establish a stronger online presence.
    </p>

  </div>


  <div
    className="portfolio-grid"
    ref={portfolioRef}
  >


    {/* =====================================================
        MWANGAZA WELLNESS
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        HEALTH & WELLNESS WEBSITE
      </span>

      <h3>
        Mwangaza Wellness
      </h3>

      <p>
        A professional wellness website designed to communicate
        services, build credibility, and create a trusted online presence.
      </p>

      <a
        href="https://mwangazawellness.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        EMMIE GIFTS
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        E-COMMERCE WEBSITE
      </span>

      <h3>
        Emmie Gift Shop
      </h3>

      <p>
        An elegant online shopping platform created to showcase
        products and provide customers with a smooth browsing experience.
      </p>

      <a
        href="https://emmiegiftshop.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        POSITIVE CORRELATION
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        BUSINESS WEBSITE
      </span>

      <h3>
        Positive Correlation
      </h3>

      <p>
        A modern business website developed to strengthen brand
        visibility and communicate services professionally.
      </p>

      <a
        href="https://positivecorrelation.com"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        STREET SMART RECRUITERS
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        RECRUITMENT WEBSITE
      </span>

      <h3>
        Street Smart Recruiters
      </h3>

      <p>
        A recruitment platform designed to connect businesses
        and candidates through a professional online presence.
      </p>

      <a
        href="https://streetsmartrecruiters.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


    {/* =====================================================
        BLOOMCART
    ===================================================== */}

    <div className="portfolio-card">

      <span className="portfolio-category">
        E-COMMERCE PLATFORM
      </span>

      <h3>
        BloomCart Kenya
      </h3>

      <p>
        A complete e-commerce solution designed to help customers
        browse products and enjoy a seamless shopping experience.
      </p>

      <a
        href="https://bloomcartke.co.ke"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-btn"
      >
        Preview Site
      </a>

    </div>


  </div>


  {/* =====================================================
      MOBILE PORTFOLIO ARROWS
  ===================================================== */}

  <div className="portfolio-arrows">

    <button
      aria-label="Previous portfolio"
      onClick={() =>
        portfolioRef.current &&
        portfolioRef.current.scrollBy({
          left: -320,
          behavior: "smooth"
        })
      }
    >
      ‹
    </button>


    <button
      aria-label="Next portfolio"
      onClick={() =>
        portfolioRef.current &&
        portfolioRef.current.scrollBy({
          left: 320,
          behavior: "smooth"
        })
      }
    >
      ›
    </button>

  </div>


</section>




{/* FAQ SECTION */}

<section className="faq-section">


  <div className="faq-header">

    <span className="faq-label">
      FREQUENTLY ASKED QUESTIONS
    </span>

    <p>
      Find answers to common questions about our website design services and how we help businesses grow online.
    </p>

  </div>


  <div className="faq-container">



    {/* FAQ 1 */}

    <div className="faq-item">

      <details>

        <summary>

          How much does website design cost in Kenya?

          <FaChevronDown />

        </summary>


        <p>
          At Satima Technova Solutions, our website design packages are structured to suit different business needs:
          <br /><br />

          Starter Website Package: From KES 12,000
          <br />
          Business Website Package: From KES 18,000
          <br />
          E-commerce / Advanced Website Package: From KES 25,000
          <br /><br />

          The final cost depends on the features, functionality, and requirements of your project.
        </p>


      </details>

    </div>





    {/* FAQ 2 */}

    <div className="faq-item">

      <details>

        <summary>

          How long does it take to build a website?

          <FaChevronDown />

        </summary>


        <p>
          Most websites are completed within 2 to 3 working days depending on the size of the project, content availability, and required features.
          We focus on delivering a professional website without compromising quality.
        </p>


      </details>

    </div>





    {/* FAQ 3 */}

    <div className="faq-item">

      <details>

        <summary>

          Will my website appear on Google?

          <FaChevronDown />

        </summary>


        <p>
          Yes. We build websites with SEO-friendly structures to help search engines understand your business.
          We also optimize important elements such as page structure, speed, and content setup to improve your chances of appearing on Google.
        </p>


      </details>

    </div>





    {/* FAQ 4 */}

    <div className="faq-item">

      <details>

        <summary>

          Do you provide website maintenance?

          <FaChevronDown />

        </summary>


        <p>
          Yes. We provide website maintenance services to keep your website secure, updated, and performing well.
          This includes updates, security checks, content changes, and technical support.
        </p>


      </details>

    </div>





    {/* FAQ 5 */}

    <div className="faq-item">

      <details>

        <summary>

          Can you redesign my existing website?

          <FaChevronDown />

        </summary>


        <p>
          Yes. We redesign outdated websites into modern, responsive, and user-friendly platforms that improve your brand image and customer experience.
        </p>


      </details>

    </div>




  </div>



</section>



       {/* =========================================================
    FINAL CTA SECTION
========================================================= */}

<section className="final-cta-section">

  <div className="final-cta-content">

    <span className="final-cta-label">
      READY TO MOVE FORWARD?
    </span>

    <h2>
      Your Business Deserves
      <br />
      <span>A Website That Works.</span>
    </h2>

    <p>
      Let's build a website that reflects your business,
      earns trust, and turns attention into action.
    </p>

    <a
      href="https://wa.me/254775137928"
      target="_blank"
      rel="noopener noreferrer"
      className="final-cta-btn"
      onClick={handleCTAClick}
    >
      Start Your Website Project
      <span>→</span>
    </a>

  </div>

</section>
      

      </main>
    </>
  );
};

export default WebDesignKenya;